export default "__VITE_ASSET__CA_75lu9__"